import type { AggregatorKind } from '../../types/api'

/** What the sign-up form offers as "Type of organisation". */
export const AGGREGATOR_KIND_CHOICES: { kind: AggregatorKind; label: string }[] = [
  { kind: 'NGO', label: 'NGO / Trust' },
  { kind: 'COMMUNITY_ORG', label: 'Organisation' },
  { kind: 'SCHOOL', label: 'School group' },
  { kind: 'COLLEGE', label: 'College' },
  { kind: 'OTHER', label: 'Other' },
]

/**
 * Every kind's name, for showing an existing account - including kinds the form no longer offers,
 * which accounts registered earlier still carry.
 */
export const AGGREGATOR_KINDS: { kind: AggregatorKind; label: string }[] = [
  ...AGGREGATOR_KIND_CHOICES,
  { kind: 'SKILLING_CENTRE', label: 'Skilling centre' },
  { kind: 'INSTITUTE', label: 'Coaching network / Institute' },
  { kind: 'CL_CENTRE', label: 'Career Launcher centre' },
  { kind: 'PRINCIPAL', label: 'Principal / Head of schools' },
]
